import { render, staticRenderFns } from "./KarteSwayFeaturesTable.vue?vue&type=template&id=75b705ca&scoped=true&"
import script from "./KarteSwayFeaturesTable.vue?vue&type=script&lang=js&"
export * from "./KarteSwayFeaturesTable.vue?vue&type=script&lang=js&"
import style0 from "./KarteSwayFeaturesTable.vue?vue&type=style&index=0&id=75b705ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75b705ca",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
